module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "component",
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus),
      expression: "getStatus"
    }],
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus),
      expression: "getStatus"
    }],
    staticClass: "inline-block"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus),
      expression: "!getStatus"
    }],
    staticClass: "inline-block icon"
  }, [_vm._v(_vm._s(_vm.closeLabel) + " "), _c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 1
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ee9e52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/deprecated/OutlineButton.vue
// module id = 975
// module chunks = 0